import $ from 'jquery'

var messageReceived = false;
export function receivePositionalMessage(a){
	if ($('#offer-frame').length != 0) {

		if(a.data.search('iframePosition') != -1){

			messageReceived = true;

			var val = parseInt(a.data.split('_')[1])

			val -= $('#offer-frame').offset().top;

			window.scrollTo(0,val);

			a.preventDefault();

			a.stopPropagation();

		}

		if(a.data.search('iframeHeight') != -1){
			messageReceived = true;

			var val = parseInt(a.data.split('_')[1])

			if(val < 600)

				$('#offer-frame').height(val);

			else

				$('#offer-frame').animate({height: val});

			a.preventDefault();

			a.stopPropagation();

		}
	}

}



//*/

export function setFrameLoaded(){
	if($(window).width() < 768)	{
		setTimeout(function(){
			if(!messageReceived){
				$('#offer-frame').height(1650);
			}
		}, 1000)
	}
}
